import { Component, OnInit, Input } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CategoriesService } from '../../../services/categories/categories.service'

@Component({
  selector: 'app-edit-category-modal',
  templateUrl: './edit-category-modal.component.html',
  styleUrls: ['./edit-category-modal.component.scss']
})
export class EditCategoryModalComponent implements OnInit {
  @Input() typeEdit;
  public typeaction:any= 'Add';
  public categoryName:string;
  constructor(
    private SpinnerService: NgxSpinnerService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private CategoriesService: CategoriesService) { }

    ngOnInit(): void {
      if(this.typeEdit) {
        this.typeaction = 'Edit';
        this.categoryName = this.typeEdit.name;
      }
    }

    close() {
      this.modalService.dismissAll();
    }

    editCategory(name){
      var categoryName = name.toUpperCase();
        // var checkstr = categoryName.includes("CATEGORIES");
        // if(!checkstr){
        //   categoryName = categoryName+' CATEGORIES';
        // }
      this.SpinnerService.show();
      this.CategoriesService.put(this.typeEdit.id, { name: categoryName})
      .then((result) => {
        this.SpinnerService.hide();
        this.close();
      })
      .catch((err)=>{
        this.SpinnerService.hide();
        console.log(err);
        this.close();
      });

    }

    addCategory(name){
      var categoryName = name.toUpperCase();
      // var checkstr = categoryName.includes("CATEGORIES");
      // if(!checkstr){
      //   categoryName = categoryName+' CATEGORIES';
      // }
      this.SpinnerService.show();
      this.CategoriesService.create({ name: categoryName})
      .then((result) => {
        this.SpinnerService.hide();
        var data = result;
        console.log(data);
        this.close();
      })
      .catch((err)=>{
        this.SpinnerService.hide();
        console.log(err);
        this.close();
      });
    }

  }
